import React from 'react';
import { Play, Square } from 'lucide-react';
import { translate } from '../../../common/i18n';

const RunButton = () => (
    <React.Fragment>
        <button title="Run the bot" id="summaryRunButton" className="toolbox-button">
            <Play size={20} />
        </button>
        <button title={translate('Stop the bot')} id="summaryStopButton" className="toolbox-button" style={{ display: 'none' }}>
            <Square size={20} />
        </button>
    </React.Fragment>
);

export default RunButton;
